import { parseHTMLToOoxmlCursively } from './HTML';
import { parseTableToOOXML, parseTRToOOXML, parseTDToOOXML } from "./HTML.Table";
import { convertToOOXML } from "./OOXML";
import { parseStyle } from "./Style";

export function parseHTMLDOM(ctx, parentOOXML, ooxmlChildren, node, pr, result) {
    switch (node.nodeName) {
        case 'BR':
            return [convertToOOXML({ tag: "w:r", children: [{tag: "w:br"}]}, parentOOXML)];
        case 'OL':
        case 'UL':
            ctx.maxNumId ++;
            ctx.numberingDetails.push({
                numId: ctx.maxNumId,
                listType: node.nodeName
            });
            const numId = ctx.maxNumId.toString();
            const listGroup = [];
            node.childNodes.forEach(li => {
                const matches = /ql-indent-(\d+)/gi.exec(li.className);
                const ilvl = matches ? matches[1] : "0";

                Array.from(li.childNodes).forEach(cn => 
                    parseHTMLToOoxmlCursively(ctx, cn, parentOOXML, pr)
                        .forEach(pr => ooxmlChildren.push(pr))
                );

                listGroup.push(convertToOOXML({ tag: "w:p", ooxmlChildren, children: [
                    {tag: "w:pPr", children: [
                        {tag: "w:numPr", children: [
                            {tag: "w:ilvl", attrs: {"w:val": ilvl}},
                            {tag: "w:numId", attrs: {"w:val": numId}}
                        ]}
                    ]},
                ]}, parentOOXML));
            });
            return listGroup;
        case "TABLE":
            return parseTableToOOXML(ctx, parentOOXML, ooxmlChildren, node);
        case "TR":
            return parseTRToOOXML(ctx, parentOOXML, ooxmlChildren, node);
        case "TD":
            return parseTDToOOXML(ctx, parentOOXML, ooxmlChildren, node)
        case "SPAN":
            result = [];
            const rpr = parseStyle(node);
            Array.from(node.childNodes).forEach(cn => {
                parseHTMLToOoxmlCursively(ctx, cn, parentOOXML).forEach(pr => {
                    if (pr._tag === "w:r") {
                        pr._children.forEach(child => {
                            if (child._tag === "w:rPr") {
                                rpr.forEach(style => {
                                    if (!child._children.find(a => a._tag === style.tag))
                                        child._children.push(convertToOOXML(style, child));
                                });
                            }
                        });
                        result.push(pr);
                    } else {
                        result.push(convertToOOXML({
                            tag: "w:r",
                            children: [{tag: "w:rPr", children: rpr}],
                            ooxmlChildren: [pr]
                        }));
                    }
                });
                
            });
            return result;

        case 'A':
            Array.from(node.childNodes).forEach(cn => {
                parseHTMLToOoxmlCursively(ctx, cn, parentOOXML, pr).forEach(pr => ooxmlChildren.push(pr));
            });
            const rtLinkId = ctx.links.length;
            ctx.links.push(node.href);
            result = [convertToOOXML({ tag: "w:hyperlink", ooxmlChildren, attrs: {"r:id": `rtLinkId${rtLinkId}`}}, parentOOXML)];
            return result;
        
        default:
            let newRPR = [...pr];
            switch (node.nodeName)  {
                case 'B':
                case 'STRONG':
                    newRPR.push(convertToOOXML({ tag: "w:b" }));
                    break;
                case 'I':
                case 'EM':
                    newRPR.push(convertToOOXML({ tag: "w:i" }));
                    break;
                case 'U':
                    newRPR.push(convertToOOXML({ attrs: {"w:val": "single"}, tag: "w:u" }));
                    break;

                default:
                    break;
            }
            Array.from(node.childNodes).forEach(cn => {
                parseHTMLToOoxmlCursively(ctx, cn, parentOOXML, newRPR).forEach(pr => result.push(pr));
            });
            return result;
    }
}